import * as types from '../actionType';

export default function SendAPIStatus(state = -1, action) {
  switch (action.type) {
    case types.EDIT_STAFF_SUCCESS:
    case types.ADD_STAFF_SUCCESS:
    case types.EDIT_PUNCHTIME_RECORD_SUCCESS:
    case types.ADD_PUNCHTIME_RECORD_SUCCESS:
      return true;
    case types.ADMIN_LOGIN_FAILURE:
    case types.EDIT_STAFF_FAILURE:
    case types.ADD_STAFF_FAILURE:
    case types.ADD_NEXT_WORK_TIME_FAILURE:
    case types.DELETE_NEXT_WORK_TIME_FAILURE:
    case types.DELETE_STAFF_IN_ADJUST_FAILURE:
    case types.EDIT_NEXT_WORK_TIME_FAILURE:
    case types.EDIT_STAFF_WORKTIME_IN_ADJUST_FAILURE:
      return action.err;
    case types.INIT_SEND_API_STATUS:
      return -1;
    case types.SERVER_ERROR_500:
      return 500;
    default:
      return state;
  }
}
